import { Component, Input, Output, EventEmitter } from '@angular/core';

import { SearchOptions } from "../../model/searchOptions";
import { Organization } from '../../model/organization';

@Component({
    selector: 'filter-info',
    templateUrl: 'filter-info.html'
})
export class FilterInformation {
    _searchOptions: SearchOptions = new SearchOptions();

    @Input()
    set searchOptions(searchOptions: SearchOptions) {
        if (searchOptions != null) {
            this._searchOptions = searchOptions;   
        }
    }
    get searchOptions(): SearchOptions {
        return this._searchOptions;
    }

    @Output() filterChanged = new EventEmitter();

    constructor() { }

    removeOrganization(organization : Organization) {
        this._searchOptions.organizations = this._searchOptions.organizations.filter(x => x.id != organization.id);
        this.filterChanged.emit(this._searchOptions);
    }

    removeEventType(eventType : string) {
        this._searchOptions.eventTypes = this._searchOptions.eventTypes.filter(x => x != eventType);
        this.filterChanged.emit(this._searchOptions);
        console.log("filter-info.removeEventType");
    }

    removeFromDate() {
        this._searchOptions.fromDate = null;
        this.filterChanged.emit(this._searchOptions);
    }

    removeToDate() {
        this._searchOptions.toDate = null;
        this.filterChanged.emit(this._searchOptions);
    }

    removeMinAddedMoney() {
        this._searchOptions.minAddedMoney = null;
        this.filterChanged.emit(this._searchOptions);
    }

    removeMaxAddedMoneyDate() {
        this._searchOptions.maxAddedMoney = null;
        this.filterChanged.emit(this._searchOptions);
    }

    removeSearchText() {
        this._searchOptions.searchText = null;
        this.filterChanged.emit(this._searchOptions);
    }
}


// WEBPACK FOOTER //
// ./src/pages/filter/filter-info.ts